import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ExternalLink } from "lucide-react";

export default function EnterpriseCard() {
  return (
    <Card className="bg-gradient-to-r from-purple-50 to-blue-50 border-purple-200">
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div className="space-y-2">
            <h3 className="text-lg font-semibold text-gray-900">Enterprise</h3>
            <p className="text-gray-600">
              Need higher limits, custom integrations, or dedicated support?
            </p>
          </div>
          <Button
            variant="outline"
            className="border-purple-300 text-purple-700 hover:bg-purple-100"
            onClick={() => window.open("https://t.me/plusefin", "_blank")}
          >
            <ExternalLink className="w-4 h-4 mr-2" />
            Contact Sales
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
